import React from 'react';
import { Label, Input, FormFeedback } from 'reactstrap';

const OInput = ({
    name,
    label,
    type = 'text',
    placeholder,
    validation, // Recibe el objeto de Formik
    classNameLabel,
    classNameInput,
    isRequired,
    onChange,
    ...rest
}) => {

    return (
        <React.Fragment>
            <Label for={`${name}-field`} className={classNameLabel}>
                {label} {isRequired && <span style={{ color: 'red' }}>*</span>}
            </Label>

            <Input
                name={name}
                id={`${name}-field`}
                className={classNameInput}
                placeholder={placeholder || `Ingrese el ${label.toLowerCase()}`}
                type={type}
                onChange={onChange ?? validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values[name] || ''}
                invalid={validation.touched[name] && validation.errors[name] ? true : false}
                {...rest}
            />
            {validation.touched[name] && validation.errors[name] ? (
                <FormFeedback type="invalid">
                    {validation.errors[name]}
                </FormFeedback>
            ) : null}
        </React.Fragment>
    );
};

export default OInput;
